module.exports = __webpack_public_path__ + "static/media/bt-download-hover.07301676.svg";